<template>
  <div class="preview-pdf">
    <iframe  :src="$pdf + '?file=' + encodeURIComponent(file)" />
  </div>
</template>
<script>
export default {
  data () {
    return {
      file: null
    }
  },
  created () {
    this.file = this.$route.query.file
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.preview-pdf {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
iframe {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
}
</style>
